import { Component, OnInit, inject ,Inject} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AuthService } from 'src/app/services/auth.service';
import { CHAR_PLUS,TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { PhoneNumberUtil } from 'google-libphonenumber';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Auth } from 'aws-amplify';
import { TUI_COUNTRIES } from '@taiga-ui/kit';
import { Observable } from 'rxjs';
import {BtbRolesCheckService} from "../../../../components/rolesCheck/btb-roles-check.service";


@Component({
  selector: 'app-edit-my-profile',
  templateUrl: './edit-profile.component.html',
})


export class EditMyProfileComponent implements OnInit {

  user = inject(AuthenticatorService).user;
  auth = inject(AuthService);
  _snackBar = inject(MatSnackBar);
  router = inject(Router);
  rolesCheck = inject(BtbRolesCheckService);
  canAccess = false;

  name: string | undefined;
  middle_name: string | undefined;
  address: string | undefined;
  country: string | undefined;

  ciudad: string | undefined;
  provincia: string | undefined;
  postcode: string | undefined;
  passport: string | undefined;

  bankAccount: string = '';


   constructor(@Inject(TUI_IS_MOBILE)
   public isMobile: boolean,
   @Inject(TUI_COUNTRIES)
  readonly countriesNames$: Observable<Record<TuiCountryIsoCode, string>>,
   private lambda: AWSLambda
  ) {

    }
    readonly countries = Object.values(TuiCountryIsoCode);
    countryIsoCode: TuiCountryIsoCode = TuiCountryIsoCode.ES;
    //selectedCountry: TuiCountryIsoCode = TuiCountryIsoCode.ES;
    countryFilter: string = '';
    selectedCountry: TuiCountryIsoCode | null = null;


  createForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    middle_name: new FormControl(''),
    'custom:address': new FormControl('', Validators.required),
    'custom:country': new FormControl('', Validators.required),
    email: new FormControl('', [Validators.email, Validators.required ]),
    phone_number: new FormControl({ value: '', disabled: true }, [Validators.required,
      Validators.pattern( '^\\+(?:[0-9] ?){6,14}[0-9]$' ),
    ]),

    'custom:ciudad': new FormControl('', Validators.required),
    'custom:provincia': new FormControl('', Validators.required),
    'custom:postcode': new FormControl('', Validators.required),
    'custom:passport': new FormControl('', Validators.required),
    bankAccount: new FormControl('', Validators.required),
  });

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    await this.auth.refresh();
    try {
      this.user = await Auth.currentAuthenticatedUser();
      console.log(this.isMobile)
        this.lambda.getLambdaFunction("lambda", "/get/userDetails").then((data) => {
          console.log('user data', data);

          this.ciudad = data['custom:ciudad'];
          this.provincia = data['custom:provincia'];
          this.postcode = data['custom:postcode'];
          this.passport = data['custom:passport'];

          this.middle_name = data['middle_name'];
          this.address = data['custom:address'];
          this.country = data['custom:country'];

          this.bankAccount = data['btbBankAccount'];

          console.log(!this.country || this.country === "")
          if (!this.country || this.country === "") {
            const phone = this.user.attributes?.phone_number;
            if (phone) {
              const detectedCountry = this.getCountryIsoCode(phone);
              // Si el campo custom:country no ha sido actualizado, asignamos el país detectado
              this.selectedCountry = detectedCountry;
              this.createForm.patchValue({ 'custom:country': detectedCountry });
            }
          } else {
            // Si el país ya está presente, simplemente asignamos el valor
            this.selectedCountry = this.country as TuiCountryIsoCode;
          }


          this.createForm.patchValue({
            name: data['name'],
            phone_number: this.user.attributes?.phone_number,
            email: this.user.attributes?.email,

            middle_name: this.middle_name,
            'custom:address': this.address,
            'custom:country': this.country,
            'custom:provincia': this.provincia,

            'custom:ciudad': this.ciudad,
            'custom:postcode': this.postcode,
            'custom:passport': this.passport,

            bankAccount: this.bankAccount,
          });
      })


    } catch (error) {
      this.auth.logout();
    }
  }

  async onUpdate() {
    try {
      this.user = await Auth.currentAuthenticatedUser();
    } catch (error) {
      this.auth.logout();
    }

    const form = this.createForm;
    const formValue = form.getRawValue();
    console.log(formValue)
    console.log(formValue['custom:address']);

    if (
      !formValue['name']?.trim() ||
      !formValue['middle_name']?.trim() ||
      !formValue['email']?.trim() ||
      !formValue['phone_number']?.trim() ||
      !formValue['custom:address']?.trim() ||
      !formValue['custom:ciudad']?.trim() ||
      !formValue['custom:provincia']?.trim() ||
      !formValue['custom:passport']?.trim() ||
      !formValue['custom:postcode']?.trim() ||
      !formValue['custom:country']?.trim() ||
      !formValue['bankAccount']?.trim()
    ) {
      this._snackBar.open('Please check the required inputs', 'Close', {
        duration: 5000,
      });
      return;
    }
    else
    {
      this.lambda.getLambdaFunction("lambda", "/crm/contact/updateProfile", {
        queryStringParameters: {
          "name": formValue['name'].trim(),
          "middle_name": formValue['middle_name'].trim(),
          "custom:address": formValue['custom:address'].trim(),
          "custom:ciudad": formValue['custom:ciudad'].trim(),
          "custom:provincia": formValue['custom:provincia'].trim(),
          "custom:postcode": formValue['custom:postcode'].trim(),
          "custom:country": formValue['custom:country'].trim(),
          "custom:passport": formValue['custom:passport'].trim(),
          "email": formValue['email'].trim(),
          "phone_number": formValue['phone_number'].trim(),
          "atributos": JSON.stringify({
            "btbBankAccount": formValue['bankAccount'].trim()
          })
        }
      }).then((result: any) => {
        if(result.ok){
          this._snackBar.open('Your profile was updated successfully', 'Close', {
            duration: 5000,
          });
          let back_url = sessionStorage.getItem('back_url');
          if (back_url != null && back_url != '') {
            this.router.navigate([back_url], { replaceUrl: true });
          } else {
            this.goBack();
          }
        }
        else
        {
          this._snackBar.open('Failed:'+result.message, 'Close', {
            duration: 5000,
          });
        }
      }).catch((error: any) => {
        this._snackBar.open('Failed to update profile. Please try again.', 'Close', {
              duration: 5000,
            });
            console.error('Error updating profile:', error);
            return;
      })
    }
  }

  goBack() {
    this.router.navigate(['btb', 'profile'], { replaceUrl: true });
  }

  getCountryIsoCode(value: string) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(CHAR_PLUS + value);
    const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
    if (region !== undefined) {
      return TuiCountryIsoCode[region as TuiCountryIsoCode];
    }
    return TuiCountryIsoCode.ES;
  }

  countryName(code: TuiCountryIsoCode): string {
    return code.replace('_', ' ');
  }

  filteredCountries(
    countries: TuiCountryIsoCode[],
    countriesNames: Record<TuiCountryIsoCode, string>,
    search: string
  ): TuiCountryIsoCode[] {
    if (!search) return countries;
    const lowerSearch = search.toLowerCase();
    return countries.filter(country =>
      countriesNames[country].toLowerCase().includes(lowerSearch)
    );
  }

  protected readonly Object = Object;
}
